// extracted by mini-css-extract-plugin
export default {"ProductInfo_container":"ProductInfoComponent_ProductInfo_container__SdS7s"};